import React from 'react'
import {connect} from 'react-redux';

class NavLink extends React.Component {

  constructor(){
    super();

    this.state={
      active: false,
      previousLocation : '',
      isMounted:false
    }

    this.gotoLink = this.gotoLink.bind(this)
    this.checkForLocationChange = this.checkForLocationChange.bind(this)
    this.requestAnimFrame = this.requestAnimFrame.bind(this)

  }

  requestAnimFrame(cb){
    let  anim = window.requestAnimationFrame       ||
                  window.webkitRequestAnimationFrame ||
                  window.mozRequestAnimationFrame    ||
                  function( callback ){
                    window.setTimeout(callback, 1000 / 60);
                  };

      ( this._ismounted === true)?
        anim(cb)
      : console.log("component not mounted, requestAnimFrame will not call");

    }


  checkForLocationChange(){

    //console.log('NavLink Check for location change');

    if(this.state.previousLocation!==window.location.pathname){
      this.checkIfActive()
      this.setState({previousLocation:window.location.pathname})
    }


    //if(this.state.isMounted===true){
      this.requestAnimFrame(this.checkForLocationChange)
    //}
  }

  checkIfActive(){

    //console.log("Check if active");

    let locationArray = window.location.pathname.toLowerCase().split('/');

        // clean out empties
        locationArray = locationArray.filter((item,index)=>{
          return (item.length)
        })

    let pathArray = this.props.to.toLowerCase().split('/');

        // clean out empties
        pathArray = pathArray.filter((item,index)=>{
          return (item.length)
        })

        //console.log(locationArray,pathArray,this.props.to);

    let active = false;
    let matches = 0


        // Count the matches

        pathArray.map((item,index)=>{
              (locationArray[index]===item)?
                matches+=1
              : null
        });

        //console.log("Matches",matches,pathArray.length);

        // if the matches the lenth the link should be active
        (matches===pathArray.length)?
          active = true
        :  active = false

        this.setState({active});
        (this.props.isActive)?
          this.props.isActive(active)
        : null ;

      //(this.props.to.toLowerCase() === window.location.pathname.toLowerCase())
  }

  componentDidMount(){
      this.setState({isMounted:true})
      this._ismounted = true;
      //this.checkForLocationChange();
      this.checkIfActive()
      this.setState({previousLocation:window.location.pathname})
  }
  componentWillUnmount(){
      this._ismounted = false;
      this.setState({isMounted:false})
  }

  componentWillUpdate(newProps,newState){
    if(newProps.route !== this.props.route){
      if(this.state.previousLocation!==window.location.pathname){
        this.checkIfActive()
        this.setState({previousLocation:window.location.pathname})
      }

    }

  }

  gotoLink(e){

    //console.log("Link",this.props.to.split("http"),this.props.to);
    if(this.props.target !=='_blank' || this.props.to.split("http").length===1){
      e.preventDefault();
      window.history.pushState(null, null, this.cleanLink());
    }

    (this.props.onClick)?
      this.props.onClick()
    : null ;




    // look for link postion
    //this.searchForAnchorPosition(this.cleanLink())
    //setTimeout(()=>this.searchForAnchorPosition(this.cleanLink()),500)
  }

  searchForAnchorPosition(currentSlug){

    let anchors = document.querySelectorAll('.scroll-anchor')
    let anchorPos = -1;

    for(let i=0; i < anchors.length;i++){

        let anchor = anchors[i]
        if(anchor.getAttribute('pageslug')){
        let anchorSlug = anchor.getAttribute('pageslug').toLowerCase();


        //Remove trailing /
        anchorSlug = anchorSlug.replace(/\/$/, '');
        currentSlug = currentSlug.replace(/\/$/, '');


        if(anchorSlug === currentSlug){


          //window.scrollTo(0,anchor.getBoundingClientRect().top)

          anchorPos = anchor.getBoundingClientRect().top+window.scrollY;

          console.log("We have a match",anchorPos,anchor.getBoundingClientRect().top);

          window.scrollTo(0,anchorPos)
          return anchorPos

        }}
        console.log(anchor.getAttribute('pageslug'));

    }

    return anchorPos


  }

  cleanLink(){

    let link = this.props.to

    // check for the stageserver
    if(link.indexOf('http://kastner.stageserver.co.uk/wp')!==-1){
        link = link.split('http://kastner.stageserver.co.uk/wp').join('')
    }

    // check for the stageserver
    if(link.indexOf('//kastner.stageserver.co.uk')!==-1){
        link = link.split('//kastner.stageserver.co.uk').join('')
    }

    return link

  }


  render(){



      //console.log('Nav Link',this.props);

      let activeClass = (this.state.active)? ' active' : ''

      let classes = (this.props.className) || ''

      let link = this.cleanLink();

      return <a href={link} className={classes+activeClass} style={this.props.style} target={this.props.target}  onClick={this.gotoLink}>{this.props.children}</a>
      //return <a href={link} className={classes+activeClass} style={this.props.style} target={this.props.target} onTap={this.gotoLink}>{this.props.children}</a>

  }

}

const mapStateToProps = (state)  => {

    //console.log(state);

    let route = state.Router.location.data


    return {
      route
    }

}

export default connect(mapStateToProps,null)(NavLink)



// WEBPACK FOOTER //
// ./src/modules/router/NavLink.js